







































































import Modal from "../core/Modals/Modal.vue";
import EmployeSelect from "../core/Forms/EmployeSelect.vue";
import { ControleVehiculeApi } from "../api/ControleVehiculeApi";
import { VehiculeFlotte } from "../models/ControleVehicule";

export default {
    name: "FlotteEditModal",
    components: { Modal, EmployeSelect },
    props: {
        showModal: Boolean,
        vehicule: Object,
    },
    data() {
        return {
            form: new VehiculeFlotte(),
            selectedChauffeur: null,
            saving: false,
            api: new ControleVehiculeApi(),
        };
    },
    methods: {
        save() {
            this.form.chauffeur_id = this.selectedChauffeur
                ? this.selectedChauffeur.id
                : null;
            this.saving = true;
            this.api
                .saveFlotte(this.form)
                .then((saved) => {
                    this.saving = false;
                    this.$emit("data-saved", saved);
                })
                .catch(() => {
                    this.saving = false;
                });
        },
        close() {
            this.$emit("close-modal");
        },
    },
    watch: {
        vehicule: {
            immediate: true,
            handler(v) {
                this.form = new VehiculeFlotte(v ? v : undefined);
                this.selectedChauffeur =
                    v && v.chauffeur_id
                        ? { id: v.chauffeur_id, fullName: v.chauffeur_nom }
                        : null;
            },
        },
    },
};
